import { html } from "lit-element";
import { DrawSVGTextBaseModule } from "../../ModuleBase/svg-text-base-module";

export class DrawCvBlueModule extends DrawSVGTextBaseModule {
	constructor(canvas) {
		super(canvas, "CV");

		this.name = "cv-blue";
		this.icon = svg_cv_blue;
		this.svgTextIndex = 2;
	}
}

window.customElements.define("inspx-draw-cv-blue-module", DrawCvBlueModule);

const svg_cv_blue = (text) => html`
<svg width="60" height="40" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
 <g>
  <title>Layer 1</title>
  <rect fill="#0026ff" stroke="#0c0c0c" x="0.09961" y="-0.08832" width="59.53381" height="39.7782" id="svg_1"/>
  <circle fill="#0026ff" cx="20.68949" cy="19.93426" r="19.38981" id="svg_2" stroke="#0f0e0e" stroke-width="2"/>
  <text fill="#000000" stroke-width="0" stroke-dasharray="null" stroke-linejoin="null" stroke-linecap="null" x="17.54522" y="19.4874" id="svg_4" font-size="24" font-family="Sans-serif" text-anchor="middle" xml:space="preserve" transform="matrix(1.7041094490789126,0,0,1.5329180932031685,0.4489083986507884,3.5733406044007943) " stroke="#0c0c0c" font-weight="bold">${text}</text>
 </g>
</svg>`;
